module.exports = "/assets/0fcc88b11187c2620a15e9b6dcdc3e94.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MM.png
// module id = 2743
// module chunks = 0